import { connect } from 'react-redux';

import { Creators as userActions } from 'Reducers/user';
import { Creators as transientActions } from 'Reducers/transient';
import { Creators as adminActions } from 'Reducers/adminOnboarding';

import SearchAddressList from './view';

export default connect(
  state => ({
    ...state.transient
  }),
  {
    getPostCodes: userActions.getPostCodes,
    getLoqateAddress: userActions.getLoqateAddress,
    updateOnboardingUserProfile: adminActions.updateOnboardingUserProfile,
    updateTransientProps: transientActions.updateProps,
    updateUser: userActions.updateApiModel
  }
)(SearchAddressList);
